import { createContext, useContext, useState } from "react";

const PropertyListContext = createContext(null);

export function PropertyListProvider({ children }) {
  const [lists, setLists] = useState({});

  const getList = (key) => {
    return lists[key] || {
      items: [],
      page: 1,
      total: 0,
      totalPages: 1,
      filters: {},
      scrollTop: 0,
    };
  };

  const updateList = (key, newState) => {
    setLists((prev) => ({
      ...prev,
      [key]: {
        ...getList(key),
        ...newState,
      },
    }));
  };

  return (
    <PropertyListContext.Provider value={{ getList, updateList }}>
      {children}
    </PropertyListContext.Provider>
  );
}

export const usePropertyListContext = () =>
  useContext(PropertyListContext);
